import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { OcbAgentAuthenticationModes } from '@app/core';
import { TranslateService } from '@ngx-translate/core';
import { DxSelectBoxComponent } from 'devextreme-angular';

@Component({
    selector: 'app-agent-authentication-mode-picker',
    templateUrl: './agent-authentication-mode-picker.component.html'
})
export class AgentAuthenticationModePickerComponent {

    @Input()
    public selectedItem: string;

    @Output()
    public selectedItemChange = new EventEmitter<string>();

    @ViewChild(DxSelectBoxComponent)
    public selectBox: DxSelectBoxComponent;

    public agentAuthenticationModes: any[] = new Array<any>();
    public loading: boolean = true;

    public constructor(private translateService: TranslateService) {
        this.translateService.get('agentAuthenticationModes').subscribe(labels => {
            for (const em in OcbAgentAuthenticationModes) {
                if (isNaN(Number(em))) {
                    this.agentAuthenticationModes.push({ name: labels[em], id: OcbAgentAuthenticationModes[em] });
                }
            }
            this.loading = false;
        });
    }

    public onSelectedItemChange($event: { name: string, id: string }) {
        if ($event == null) {
            return;
        }
        this.selectedItemChange.emit($event.id);
    }
}
